import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * The thin ✕ drawn inside a field to clear it. Replaces the Font Awesome `fa-times` glyph, which
 * reads heavy at field size; this one is a 17px box with a 1.5 stroke, matching the ✕ in the Deck
 * Comparisons modal (RA-2738). Drawn in `currentColor`, so the host button sets its colour and
 * hover state. Decorative only: the button that wraps it carries the accessible name.
 */
@Component({
  selector: 'rms-clear-icon',
  templateUrl: './clear-icon.component.html',
  styleUrl: './clear-icon.component.scss',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClearIconComponent {}
